import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, StarIcon, SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-gradient-to-b from-[#1e293b] to-[#0f172a] py-16 md:py-24 relative overflow-hidden" data-id="element-94">
      {/* Decorative stars */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-95">
        <StarIcon className="absolute top-10 left-[10%] w-4 h-4 text-[#d4a853]/40" data-id="element-96" />
        <StarIcon className="absolute top-20 right-[15%] w-3 h-3 text-[#f5c542]/30" data-id="element-97" />
        <StarIcon className="absolute bottom-20 left-[20%] w-5 h-5 text-[#d4a853]/25" data-id="element-98" />
        <StarIcon className="absolute bottom-40 right-[25%] w-4 h-4 text-[#f5c542]/35" data-id="element-99" />
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-101">
          {/* Special highlight container */}
          <div className="relative" data-id="element-102">
            <div className="absolute inset-0 bg-gradient-to-r from-[#d4a853]/10 via-[#f5c542]/5 to-[#d4a853]/10 rounded-3xl blur-xl" data-id="element-103" />
            <div className="relative bg-[#0f172a]/80 border-2 border-[#d4a853]/40 rounded-3xl p-8 md:p-12 backdrop-blur-sm" data-id="element-104">
              <div className="flex items-center justify-center gap-4 mb-8" data-id="element-105">
                <MoonIcon className="w-10 h-10 text-[#d4a853]" data-id="element-106" />
                <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center" data-id="element-107">
                  El Protocolo de{' '}
                  <span className="text-[#f5c542]" data-id="element-108">7 Minutos</span>
                </h2>
                <SparklesIcon className="w-10 h-10 text-[#d4a853]" data-id="element-109" />
              </div>

              <div className="space-y-6 text-gray-300 text-lg md:text-xl leading-relaxed" data-id="element-110">
                <p data-id="element-111">
                  Este no es un manual de entrenamiento de obediencia. Es una
                  técnica de{' '}
                  <span className="text-[#d4a853] font-semibold" data-id="element-112">
                    "Aterrizaje Biológico"
                  </span>
                  .
                </p>

                <p data-id="element-113">
                  En lugar de pelear contra el instinto del bebé, usamos el{' '}
                  <span className="text-[#f5c542] font-semibold" data-id="element-114">
                    Anclaje de Seguridad Sensorial
                  </span>{' '}
                  para desactivar su sistema de alerta.
                </p>

                <p data-id="element-115">
                  Al imitar las vibraciones y el ritmo del útero en pasos
                  exactos de 120 segundos, logramos que su cerebro segregue
                  melatonina de forma natural,{' '}
                  <span className="text-white font-semibold" data-id="element-116">
                    permitiendo que pase de un ciclo de sueño a otro sin
                    despertarse.
                  </span>
                </p>
              </div>

              {/* Decorative glow */}
              <div className="absolute -top-2 -left-2 w-4 h-4 bg-[#d4a853] rounded-full blur-sm" data-id="element-117" />
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-[#f5c542] rounded-full blur-sm" data-id="element-118" />
              <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-[#f5c542] rounded-full blur-sm" data-id="element-119" />
              <div className="absolute -bottom-2 -right-2 w-4 h-4 bg-[#d4a853] rounded-full blur-sm" data-id="element-120" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}